import { AddAssistantsModal } from '@forwardflow/modals/AddAssistantsModal'
import { AssistantsList } from './AssistantsList'
import { useAddAssistantsModalStore } from '@forwardflow/store/modal/AddAssistantsModal'

export const SetAssistants = () => {
   const { openAddAssistantsModal } = useAddAssistantsModalStore()
   return (
      <>
         <div className="flex flex-col flex-1">
            <div className="flex items-center justify-between py-3 pl-10 pr-4">
               <span className="font-medium">Assistants</span>
               <div className="gap-2 flexc">
                  <button
                     className="h-10 font-medium transition-all rounded w-44 bg-primary/20 hover:bg-primary/40"
                     onClick={openAddAssistantsModal}
                  >
                     Add Assistant
                  </button>
               </div>
            </div>

            <AssistantsList edit={false} />
         </div>
         <AddAssistantsModal />
      </>
   )
}
